export interface RuntimeConfig {
  REACT_APP_API_BASE_URL: string;
  REACT_APP_IMAGE_URL:string;
  REACT_APP_IMAGE_THUMBNAIL_URL:string;
}
let runtimeConfig: RuntimeConfig | null = null;
export async function loadRuntimeConfig(): Promise<void> {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error('Failed to load runtime config');
  }
  runtimeConfig = await response.json();
}



export function getRuntimeConfig(): RuntimeConfig {
  if (!runtimeConfig) {
    throw new Error('Runtime config not loaded yet');
  }
  return runtimeConfig;
}